export default __webpack_public_path__ + "static/media/ketopopcorn@2x.9e7bba15.jpg";